<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   icon="components_coordinate_link_window"></tm-menubar-button>
